import React from 'react';
import FeatureCarousel from '../../Slider/FeatureCarousel';

export default function FeaturesSectionStyle4({ sectionTitle, data, useVisionMissionDesign }) {
  return <FeatureCarousel sectionTitle={sectionTitle} data={data} useVisionMissionDesign={useVisionMissionDesign} />;
}
